<template>
  <div>
    <label class="regra-modal__rotulo">Promoções que não contam para o limite</label>
    <div class="regra-negocio-promocoes__escolha mb-3">
      <SeletorBusca
        :value="promocaoEscolhida"
        :opcoes="opcoesPromocoes"
        placeholder="Busque a promoção por código ou descrição"
        aria-label="Desconsiderar promoção"
        texto-vazio="Nenhuma promoção encontrada"
        :erro="erroCarga"
        @abrir="$emit('recarregar')"
        @change="aoEscolherPromocao"
      >
        <template #opcao="{ opcao }">
          <ItemPromocao :item="opcao.promocao" />
        </template>
      </SeletorBusca>
      <CButton
        color="primary"
        variant="outline"
        class="regra-negocio-promocoes__todas"
        :title="`Desconsiderar as próximas ${Math.min(totalDisponiveis, 15)} promoções da lista`"
        :disabled="!totalDisponiveis"
        @click="addAllItems"
      >
        <fa-icon icon="plus" class="mr-1" />
        Próximas {{ Math.min(totalDisponiveis, 15) }}
      </CButton>
    </div>
    <div class="regra-modal__caixa">
      <div class="regra-modal__caixa-cabecalho">
        <strong>Promoções desconsideradas</strong>
        <span>Exibindo {{ filteredPromocoesSelecionadas.length }} de {{ promocoesSelecionadas.length }}</span>
      </div>
      <div class="regra-negocio-promocoes__filtro">
        <input
          class="form-control"
          placeholder="Pesquisar por ID ou descrição"
          type="text"
          aria-label="Pesquisar promoção desconsiderada"
          v-model="searchQueryFiltered"
        />
        <CButton
          color="danger"
          variant="outline"
          title="Remover todas"
          :disabled="!promocoesSelecionadas.length"
          @click="removeAllItems"
        >
          <fa-icon icon="trash-alt" />
        </CButton>
      </div>
      <ul class="regra-negocio-promocoes__lista">
        <li v-if="promocoesSelecionadas.length === 0" class="regra-negocio-promocoes__vazio">
          Nenhuma promoção a ser desconsiderada
        </li>
        <li v-for="item in filteredPromocoesSelecionadas" :key="item.id" class="regra-negocio-promocoes__item">
          <ItemPromocao :item="item" />
          <CButton
            size="sm"
            color="danger"
            variant="ghost"
            title="Voltar a considerar esta promoção"
            :aria-label="`Voltar a considerar a promoção ${item.id}`"
            @click="deselectItem(item)"
          >
            <fa-icon icon="trash-alt" />
          </CButton>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import _filter from "lodash/filter";
import _some from "lodash/some";
import { isNumeric, normalizeString } from "@/helpers/utils";
import ItemPromocao from "./ItemPromocao.vue";
import SeletorBusca from "@/components/form/SeletorBusca.vue";

export default {
  name: "multiselectable",
  components: {
    ItemPromocao,
    SeletorBusca,
  },
  props: ["regra", "promocoes", "promocoesSelecionadas", "selectCallback", "deselectCallback", "erroCarga"],

  data() {
    return {
      promocaoEscolhida: null,
      searchQueryFiltered: "",
    };
  },

  computed: {
    totalDisponiveis() {
      return Math.max(this.promocoes.length - this.promocoesSelecionadas.length, 0);
    },

    opcoesPromocoes() {
      return _filter(this.promocoes, (item) => {
        return !_some(this.promocoesSelecionadas, (selected) => `${selected.promocao_id}` === `${item.id}`);
      }).map((item) => ({ id: item.id, descricao: item.descricao, promocao: item }));
    },

    filteredPromocoesSelecionadas() {
      const promocoesSelecionadas = _filter(this.promocoes, (item) => {
        return _some(this.promocoesSelecionadas, (selected) => `${selected.promocao_id}` === `${item.id}`);
      }).slice(0, 15);

      if (this.searchQueryFiltered === "") {
        return promocoesSelecionadas;
      }

      if (isNumeric(this.searchQueryFiltered)) {
        return promocoesSelecionadas.filter((item) => `${item.id}`.startsWith(`${this.searchQueryFiltered}`));
      }

      return promocoesSelecionadas.filter((item) => {
        return normalizeString(String(item.descricao || "").toLowerCase()).includes(normalizeString(this.searchQueryFiltered.toLowerCase()));
      });
    },
  },

  methods: {
    aoEscolherPromocao(valor, opcao) {
      this.promocaoEscolhida = valor;

      if (opcao && opcao.promocao) this.selectItem(opcao.promocao);

      this.$nextTick(() => {
        this.promocaoEscolhida = null;
      });
    },

    selectItem(item) {
      this.selectCallback({ ...item, promocao_id: item.id });
    },

    deselectItem(item) {
      this.deselectCallback(item["id"]);
    },

    diffItems(items) {
      return _filter(items, (item) => {
        return !_some(this.promocoesSelecionadas, (selected) => `${selected.promocao_id}` === `${item.id}`);
      }).slice(0, 15);
    },

    removeAllItems() {
      [...this.promocoesSelecionadas].forEach((item) => {
        this.deselectCallback(item["promocao_id"]);
      });
    },

    addAllItems() {
      this.diffItems(this.promocoes).forEach((item) => {
        this.selectCallback({ ...item, promocao_id: item.id });
      });
    },
  },
};
</script>

<style scoped src="@/components/regras/regra-modal.css"></style>

<style scoped>

.regra-negocio-promocoes__escolha {
  display: flex;
  gap: 8px;
}

.regra-negocio-promocoes__todas {
  flex-shrink: 0;
  white-space: nowrap;
}

.regra-negocio-promocoes__filtro {
  display: flex;
  gap: 6px;
  padding: 10px 14px;
  border-bottom: 1px solid #f2f4f7;
}

.regra-negocio-promocoes__lista {
  max-height: 320px;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  list-style: none;
}

.regra-negocio-promocoes__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 14px;
  border-bottom: 1px solid #f2f4f7;
}

.regra-negocio-promocoes__item:hover {
  background-color: #f9fafb;
}

.regra-negocio-promocoes__vazio {
  padding: 24px 14px;
  text-align: center;
  font-size: 12.5px;
  color: #98a2b3;
}
</style>
